import { create } from 'zustand';

interface AIVideoState {
  currentStep: number;
  answers: {
    videoGoal?: string;
    experience?: string;
    challenge?: string;
    impact?: string;
    aiFamiliarity?: string;
    email?: string;
    phone?: string;
  };
  setCurrentStep: (step: number) => void;
  setAnswer: (key: keyof AIVideoState['answers'], value: string) => void;
  nextStep: () => void;
  previousStep: () => void;
  reset: () => void;
}

export const useAIVideoStore = create<AIVideoState>((set, get) => ({
  currentStep: 1,
  answers: {},
  setCurrentStep: (step) => set({ currentStep: step }),
  setAnswer: (key, value) => set((state) => ({
    answers: { ...state.answers, [key]: value }
  })),
  nextStep: () => set((state) => ({ currentStep: state.currentStep + 1 })),
  previousStep: () => set((state) => ({ 
    currentStep: Math.max(1, state.currentStep - 1) 
  })),
  reset: () => set({ currentStep: 1, answers: {} }),
}));